"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWeekPicker = void 0;
var react_1 = __importStar(require("react"));
var react_common_lib_1 = require("@esub-engineering/react-common-lib");
var _1 = require(".");
var utils_1 = require("../../utils");
var types_1 = require("../../types");
var useWeekPicker = function (_a) {
    var startingDate = _a.startingDate, weekEnding = _a.weekEnding;
    var _b = (0, react_1.useState)(startingDate), weekStartDate = _b[0], setWeekStartDate = _b[1];
    var _c = (0, react_1.useState)(function () {
        var _a = (0, utils_1.getDatesByWeekEnding)(weekEnding, startingDate), startDate = _a.startDate, endDate = _a.endDate;
        var weekRange = {
            start: (0, react_common_lib_1.convertToISODate)(startDate),
            end: (0, react_common_lib_1.convertToISODate)(endDate),
        };
        return weekRange;
    }), week = _c[0], setWeek = _c[1];
    var setWeekDates = (0, react_1.useCallback)(function (start) {
        var _a = (0, utils_1.getDatesByWeekEnding)(weekEnding, start), startDate = _a.startDate, endDate = _a.endDate;
        var weekRange = {
            start: (0, react_common_lib_1.convertToISODate)(startDate),
            end: (0, react_common_lib_1.convertToISODate)(endDate),
        };
        // format: YEAR-MONTH-DATE
        // bypass ISO date conversion and manually parse year, month and day CP-
        // const localStartDates = new Date(startDate)
        //   .toLocaleDateString()
        //   .split("/");
        // const localEndDates = new Date(endDate).toLocaleDateString().split("/");
        // const weekRange: IWeekRange = {
        //   start: `${localStartDates[2]}-${localStartDates[0]}-${localStartDates[1]}`,
        //   end: `${localEndDates[2]}-${localEndDates[0]}-${localEndDates[1]}`,
        // };
        return weekRange;
    }, [weekEnding]);
    var onWeekChange = (0, react_1.useCallback)(function (direction, dateToSet) {
        var date = dateToSet || weekStartDate;
        if (direction === types_1.WeekPickerDateDirection.INCREASE) {
            date.setDate(date.getDate() + 7);
        }
        else if (direction === types_1.WeekPickerDateDirection.DECREASE) {
            date.setDate(date.getDate() - 7);
        }
        var updatedWeekDates = setWeekDates(date);
        setWeek(updatedWeekDates);
        setWeekStartDate(date);
        return updatedWeekDates;
    }, [weekStartDate, setWeekDates]);
    (0, react_1.useEffect)(function () {
        setWeek(setWeekDates(weekStartDate));
        // only needed to reset dates when week ending day changes by the component
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [weekEnding]);
    return {
        startDate: startingDate && weekEnding ? week.start : null,
        endDate: startingDate && weekEnding ? week.end : null,
        changeWeekView: onWeekChange,
        Picker: react_1.default.memo(_1.WeekPicker),
    };
};
exports.useWeekPicker = useWeekPicker;
